export const members_114 = [
  {
    imgURL: "/images/members/114/member_ms_11401.jpg",
    name: {
      chinese: "黃品叡",
      english: "PIN RUI HUANG",
    },
    email: "boyhuanggordon@gmail.com",
    spec: "TypeScript, Rust",
  },
  {
    imgURL: "/images/members/114/member_ms_11402.jpg",
    name: {
      chinese: "陳冠仲",
      english: "KUAN CHUNG CHEN",
    },
    email: "kcchen0105@gmail.com",
    spec: "C, C++, Python",
  },
  {
    imgURL: "/images/members/114/member_ms_11403.jpg",
    name: {
      chinese: "張中瑋",
      english: "CHUNG WEI CHANG",
    },
    email: "puli1031@gmail.com",
    spec: "C++, Python",
  },
  {
    imgURL: "/images/members/114/member_ms_11404.jpg",
    name: {
      chinese: "黃莉媞",
      english: "LI TI HUANG",
    },
    email: "vivian9217888@gmail.com",
    spec: "C, Python",
  },
  {
    imgURL: "/images/members/114/member_ms_11405.jpg",
    name: {
      chinese: "張亦翔",
      english: "YI HSIANG CHANG",
    },
    email: "a0909447770@gmail.com",
    spec: "C, C++",
  },
];
